module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "selected": _vm.selected
    },
    on: {
      "mousedown": function($event) {
        _vm.selectShade(_vm.shade);
      }
    }
  }, [_c('Draggable', {
    staticClass: "shade-preview",
    style: ({
      'background-color': _vm.color
    })
  }), _vm._v(" "), _c('span', [_c('div', [(_vm.number) ? _c('span', [_vm._v(_vm._s(_vm.number) + " .")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.name) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.reference))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-925ae26c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_module/shade-list-tile.vue
// module id = 3318
// module chunks = 0